import React from 'react';
import { BwLogoGlyph } from './icons';
import { ServetWordmark } from './ServetWordmark';

interface LandingNavProps {
  onSignIn: () => void;
  onRequestAccess: () => void;
}

const NAV_LINKS = [
  { href: '#evidence', label: 'Evidence' },
  { href: '#scoring', label: 'Scoring' },
  { href: '#workflow', label: 'How it works' },
  { href: '#product', label: 'Product' },
];

/** Sticky, blurred public-landing nav. Auth actions open the existing modals. */
export function LandingNav({ onSignIn, onRequestAccess }: LandingNavProps) {
  return (
    <header className="sticky top-0 z-50 bg-bw-app/80 backdrop-blur-md border-b border-bw-border">
      <div className="max-w-[1180px] mx-auto px-5 sm:px-8 py-3.5 flex items-center justify-between gap-4 sm:gap-6">
        {/* Brand lockup */}
        <a href="#top" className="flex items-center gap-2.5 flex-none no-underline">
          <span className="w-[34px] h-[34px] rounded-[9px] bg-bw-primary text-white flex items-center justify-center">
            <BwLogoGlyph className="w-[17px] h-[17px]" />
          </span>
          <span className="text-[19px] font-extrabold tracking-tight text-bw-ink">BidWin</span>
          <span className="hidden sm:inline-block w-px h-5 bg-neutral-300 mx-0.5" />
          <span className="hidden sm:flex items-center gap-1.5 font-mono text-[10px] font-medium tracking-wide text-bw-muted">
            from <ServetWordmark variant="light" />
          </span>
        </a>

        {/* Center anchors */}
        <nav className="hidden md:flex items-center gap-7 flex-1 justify-center min-w-0">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm font-medium text-fit-weak hover:text-bw-primary transition-colors no-underline"
            >
              {l.label}
            </a>
          ))}
        </nav>

        {/* Auth actions */}
        <div className="flex items-center gap-3 sm:gap-3.5 flex-none">
          <button
            onClick={onSignIn}
            className="text-sm font-semibold text-bw-primary whitespace-nowrap hover:opacity-80 transition-opacity"
          >
            Sign in
          </button>
          <button
            onClick={onRequestAccess}
            className="text-sm font-semibold text-white bg-bw-primary px-3.5 sm:px-[18px] py-2 rounded-lg shadow-sm hover:brightness-110 transition whitespace-nowrap"
          >
            Request access
          </button>
        </div>
      </div>
    </header>
  );
}
